import React from 'react';

function Footer() {
  return (
    <footer className='w-full h-[80px] flex justify-center items-center px-4 bg-[#0a192f] text-gray-300'>
        <div>
            <p>&copy; 2022 colesilvernail.com</p>
        </div>
    </footer>
  )
}

export default Footer